import { FC } from 'react'

const Loading: FC<{
  isfullScreen?: boolean
  size?: 'tyny' | 'small' | 'medium' | 'large'
}> = ({ isfullScreen, size = 'medium' }) => (
  <div className='flex justify-center w-[100%]'>
    <div
      className={`${
        {
          tyny: '',
          small: '',
          medium: 'w-[3em] h-[3em]',
          large: '',
        }[size]
      }`}
    >
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
        <circle
          fill='none'
          strokeOpacity='1'
          stroke='#EC6813'
          strokeWidth='.5'
          cx='100'
          cy='100'
          r='0'
        >
          <animate
            attributeName='r'
            calcMode='spline'
            dur='2'
            values='1;80'
            keyTimes='0;1'
            keySplines='0 .2 .5 1'
            repeatCount='indefinite'
          ></animate>
          <animate
            attributeName='strokeWidth'
            calcMode='spline'
            dur='2'
            values='0;25'
            keyTimes='0;1'
            keySplines='0 .2 .5 1'
            repeatCount='indefinite'
          ></animate>
          <animate
            attributeName='strokeOpacity'
            calcMode='spline'
            dur='2'
            values='1;0'
            keyTimes='0;1'
            keySplines='0 .2 .5 1'
            repeatCount='indefinite'
          ></animate>
        </circle>
      </svg>
    </div>
  </div>
)

export default Loading
